<script setup>

import {computed, onMounted, reactive, watch} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";
import {userStore} from "@/Stores/UserStore";

const compName = 'MessagesComponent';

const props = defineProps({
  contextSchemaA: String,
  clientId: null
});


onMounted(() => {
  listAll()
});


const data = reactive({
  headers: [
    { title: 'Date/Time', key: 'time', },
    { title: 'Sent By', key: 'name' },
    { title: 'Message', key: 'message' },
    { title: 'Claim Number', key: 'claimnumber'},
    { title: 'Age', key: 'age' },
    { title: 'Person Insured', key: 'insuredname' },
    { title: 'Client', key: 'client' },
  ],
  loading: false,
  messages: [],
  search: null,
  timezone: new Date()
});

watch(() => props.clientId, async (val) => {
  listAll();
});

const csvData = computed(()=>{

  // CSV File
  return data.messages.map((item) => ({
    ...item,
    message: item.message,
    name: item.name,
    time: formatTimestampByLocale(item.time),
  }))
});

const csvExport = (arrData) => {
  // CSV File
  let csvContent = 'data:text/csv;charset=utf-8,'
  csvContent += [
    Object.keys(arrData[0]).join(';'),
    ...arrData.map((item) => Object.values(item).join(';')),
  ]
      .join('\n')
      .replace(/(^\[)|(\]$)/gm, '')

  const data = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', 'export.csv')
  link.click()
};

const formatTimestampByLocale = (timestamp) => {
  const date = new Date(timestamp)
  return date.toLocaleString()
};

const getTimezone = () => {
  const tzName = data.timezone
  return tzName.toLocaleString('en', {timeZoneName: 'short'}).split(' ').pop();
};

const listAll = () => {
  data.loading = true;
  ApiWrapper.post('messaging','list-messages', {
    clientId: props.clientId
  })
      .then((response) => {
        data.messages = response.messages;
        data.loading = false
      })
      .catch((error) => {
        ToastUtil.error(error);
        data.loading = false;
      });
}


</script>

<template>
  <v-container id="entreos-resize-target" fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Messages</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-icon @click="csvExport(csvData)" v-if="data.messages.length"> mdi-file-download</v-icon>
      </v-toolbar>
      <v-data-table :items="data.messages" :headers="data.headers" :search="data.search" :items-per-page="10"
                    :items-per-page-options="[1, 5, 10]">
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.claimid}`">
            {{ item.claimnumber }}
          </RouterLink>
        </template>
        <template v-slot:[`item.time`]="{ item }">
          {{ formatTimestampByLocale(item.time) }} - {{ getTimezone(data.timezone) }}
        </template>
        <template v-slot:[`item.client`]="{ item }">
          <RouterLink :to="`/client/${item.clientid}`">
            {{ item.client }}
          </RouterLink>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>